import type {Component} from 'grapesjs';
import {POSTERMYWALL_SIGNUP_FORM_TYPE} from '@FormMakerReact/components/postermywall-signup-form/postermywall-signup-form';

export function isUnderSignupForm(component: Component): boolean {
  const parent = component.parent();
  if (!parent) {
    return false;
  }
  return parent.get('type') === POSTERMYWALL_SIGNUP_FORM_TYPE;
}
